import React, { useEffect, useState } from 'react';
const DAYS_ES = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
function useCountdown() {
  const FIXED_SECONDS = 15 * 60; // 15:00 minutes
  const [seconds, setSeconds] = useState(FIXED_SECONDS);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
export function TopBar() {
  const countdown = useCountdown();
  const dayName = DAYS_ES[new Date().getDay()];
  return <div className="fixed left-0 right-0 z-40 flex items-center justify-center px-4 py-2 text-white" style={{
    top: '36px',
    backgroundColor: '#ffffff',
    minHeight: '44px',
    borderBottom: '1px solid #e5e5e5'
  }} data-id="element-229">
      <div className="flex items-center gap-2 text-center" data-id="element-230">
        <span className="text-lg" data-id="element-231">⏰</span>
        <span className="text-sm sm:text-base font-bold tracking-wide" style={{
        color: '#1a1a1a'
      }} data-id="element-232">
          ¡OFERTA 4x1 SOLO POR HOY{' '}
          <span className="font-black" style={{
          color: '#8b1a1a',
          textDecoration: 'underline',
          textDecorationColor: '#8b1a1a',
          textUnderlineOffset: '3px'
        }} data-id="element-233">
            {dayName}
          </span>
          {'! '}
          Finaliza en{' '}
          <span className="font-black" style={{
          color: '#8b1a1a'
        }} data-id="element-234">
            {countdown}
          </span>
        </span>
      </div>
    </div>;
}